
import Navbar from './common/Navbar'
import LandingPage from './common/LandingPage'
import AboutMe from './common/AboutMe'
import Experience from './common/Experience'
import Projects from './common/Projects'
import ContactMe from './common/ContactMe'
import Skills from './common/Skills'
function App() {
  return (
   <>
    <Navbar />
    <LandingPage />
    <AboutMe />
    <Skills />
    <Experience />
    <Projects />
    <ContactMe />
    </>
  );
}

export default App;
